import {useIntl} from "react-intl";
import {Field, useFormikContext} from "formik";
import { typeIdentification, cities, typeIdentificationSpecifics } from "../../../__mocks__/data";
import './applicant-info.scss';
import {useRequestContext} from "../../../hooks/useRequestContext";
import { renderTypeIdentificationDescription } from "../../../utils/utils";
import { useEffect, useState } from "react";
import { AdminService, WLOCreditAPIService } from "../../../services";
import _ from "lodash";
import moment from "moment";

interface FormLegalRepresentativeProps {
    errors?: any;
    touched?: any;
    values?: any;
}


export function FormLegalRepresentative(props: FormLegalRepresentativeProps) {
    const {errors, touched, values} = props;
    const intl = useIntl();
    const {request} = useRequestContext();
    const [allCiudades, setAllCiudades] = useState(cities as any);
      const { setFieldValue } = useFormikContext<any>();

    

    const hasError = (fieldName: string) => {
        return errors[fieldName] && touched[fieldName];
        //return errors[fieldName] ;
    };

     let citiesDepent2 = {
            "ListCiudad": {
                "Datos_Ciudad": [] as any
            }
        }

    useEffect(() => {
      AdminService.getAllCiudades().then((Datos:any)=>{
        console.log('Datos', Datos.payload.data.ListCiudad.Datos_Ciudad);
                citiesDepent2.ListCiudad.Datos_Ciudad  = _.filter(Datos.payload.data.ListCiudad.Datos_Ciudad, { s_nivel: '3'});
                   setAllCiudades(citiesDepent2);
                 
      })
     
    }, []);

    const consuptaRepLegal = async () => {
        if (!values.Pws_Rep_Legal_Tipo_ID || !values.Pws_Rep_Legal_Identificacion) {
            return;
        }

        try {
            const resultConsultaPersona = await WLOCreditAPIService.consultaSolicitudCygnus({
                Pws_Identificacion: values.Pws_Rep_Legal_Identificacion,
                Pws_Tip_Identificacion: values.Pws_Rep_Legal_Tipo_ID,
            });

            if (!_.isEmpty(resultConsultaPersona.payload)) {
               const cygnus = resultConsultaPersona.payload.data.datos_persona.Datos_persona[0];

            if (cygnus) {
                    const fieldsMap = {
                        Pws_Rep_Legal_I_Codigo: cygnus.Pws_i_codigo,
                        // Pws_i_codigo: cygnus.Pws_i_codigo,
                        Pws_Rep_Legal_Tipo_ID: cygnus.Pws_Tip_Identificacion,
                        Pws_Rep_Legal_Identificacion: cygnus.Pws_Identificacion,
                        Pws_Rep_Legal_Nombres: cygnus.Pws_Nombres,
                        Pws_Rep_Legal_Apellidos: cygnus.Pws_Apellidos1,
                        Pws_Rep_Legal_Lugar_Exp: cygnus.Pws_Lugar_exp,
                        Pws_Rep_Legal_Fecha_Exp: cygnus.Pws_Fec_expe
                            ? moment(cygnus.Pws_Fec_expe.split('-00')[0]).format("YYYY-MM-DD")
                            : '',
                        Pws_Rep_Legal_Direccion: cygnus.Pws_Direccion_res,
                        Pws_Rep_Legal_Telefono: cygnus.Pws_Telefono1,
                        Pws_Rep_Legal_Correo: cygnus.Pws_Correo,
                        Pws_Rep_Legal_Ciudad: cygnus.Pws_Ciudad_res,
                    };

                    Object.entries(fieldsMap).forEach(([field, value]) => {
                        if (value !== undefined && value !== null) {
                            setFieldValue(field, value);
                        }
                    });
                }
            }
        } catch (error) {
            console.error('Error en la consulta del representante legal:', error);
        }
    };

    return (
        <div className="container-border-app" style={{marginTop: '20px'}}>
            <div className="row">
                <div className="col-12 text-left">
                    <h3>Datos del representante legal</h3>
                </div>
            </div>

            {/* Fila 1 */}
            <div className="row">
                <div className="col">
                    <div className="label-fields-peps-mobile display-flex">Nombres</div>
                    <div className="display-flex">
                        <Field name="Pws_Rep_Legal_Nombres"
                            className={`form-know-you-item-input-smaller display-flex ${
                                hasError('Pws_Rep_Legal_Nombres') ? 'input-error' : ''
                            }`} />
                    </div>
                </div>

                <div className="col">
                    <div className="label-fields-peps-mobile display-flex">Primer Apellido</div>
                    <div className="display-flex">
                        <Field name="Pws_Rep_Legal_Apellidos"
                            className={`form-know-you-item-input-smaller display-flex ${
                                hasError('Pws_Rep_Legal_Apellidos') ? 'input-error' : ''
                            }`} />
                    </div>
                </div>

                {/* <div className="col">
                    <div className="label-fields-peps-mobile display-flex">Segundo Apellido</div>
                    <div className="display-flex">
                        <Field name="Pws_Apellidos2"
                            className={`form-know-you-item-input-smaller display-flex ${
                                hasError('Pws_Apellidos2') ? 'input-error' : ''
                            }`} />
                    </div>
                </div> */}

                {/* <div className="col">
                    <div className="label-fields-peps-mobile display-flex">Tipo Identificación</div>
                    <div className="display-flex">
                        <Field as="select" name="Pws_Rep_Legal_Tipo_ID"
                            className={`form-know-you-item-input-smaller display-flex ${
                                hasError('Pws_Rep_Legal_Tipo_ID') ? 'input-error' : ''
                            }`}>
                            <option value="">Seleccione...</option>
                            {typeIdentificationSpecifics?.WS_TIPOS_IDENTIFICACION_IResult?.LstTiposIdent?.Datos_TiposIdentificacion?.map((item, key) => (
                                <option key={key} value={item.s_codigo}>{item.s_descripcion}</option>
                            ))}
                        </Field>
                    </div>
                </div> */}

                
                {/* <div className="col">
                    <div className="label-fields-peps-mobile display-flex">Número de identificación</div>
                    <div className="display-flex">
                        <Field name="Pws_Rep_Legal_Identificacion"
                            className={`form-know-you-item-input-smaller display-flex ${
                                hasError('Pws_Rep_Legal_Identificacion') ? 'input-error' : ''
                            }`} />
                    </div>
                </div> */}

                <div className="col">
                    <div className="label-fields-peps-mobile display-flex">Tipo Identificación</div>
                    <div className="display-flex">
                        <Field
                            as="select"
                            name="Pws_Rep_Legal_Tipo_ID"
                            className={`form-know-you-item-input-smaller display-flex ${
                                hasError('Pws_Rep_Legal_Tipo_ID') ? 'input-error' : ''
                            }`}
                            onBlur={consuptaRepLegal}
                        >
                            <option value="">Seleccione...</option>
                            {typeIdentificationSpecifics?.WS_TIPOS_IDENTIFICACION_IResult?.LstTiposIdent?.Datos_TiposIdentificacion?.map((item, key) => (
                                <option key={key} value={item.s_codigo}>{item.s_descripcion}</option>
                            ))}
                        </Field>
                    </div>
                </div>

                <div className="col">
                    <div className="label-fields-peps-mobile display-flex">Número de identificación</div>
                    <div className="display-flex">
                        <Field
                            name="Pws_Rep_Legal_Identificacion"
                            className={`form-know-you-item-input-smaller display-flex ${
                                hasError('Pws_Rep_Legal_Identificacion') ? 'input-error' : ''
                            }`}
                            onBlur={consuptaRepLegal}
                        />
                    </div>
                </div>

            </div>

            {/* Fila 2 */}
            
            <div className="row">
                <div className="col">
                    <div className="label-fields-peps-mobile display-flex">Lugar expedición</div>
                    <div className="display-flex">
                        <Field as="select" name="Pws_Rep_Legal_Lugar_Exp"
                            className={`form-know-you-item-input-smaller display-flex ${
                                hasError('Pws_Rep_Legal_Lugar_Exp') ? 'input-error' : ''
                            }`}>

                            <option value="">Seleccione...</option>
                            {allCiudades?.ListCiudad?.Datos_Ciudad?.map((item:any, key: number) => (
                                <option key={key} value={item.s_codigo}>{item.s_nombre}</option>
                            ))}
                        </Field>
                    </div>
                </div>

                <div className="col">
                    <div className="label-fields-peps-mobile display-flex">Fecha expedición</div>
                    <div className="display-flex">
                        <Field name="Pws_Rep_Legal_Fecha_Exp" type="date"
                            className={`form-know-you-item-input-smaller display-flex ${
                                hasError('Pws_Rep_Legal_Fecha_Exp') ? 'input-error' : ''
                            }`} />
                    </div>
                </div>


                <div className="col">
                    <div className="label-fields-peps-mobile display-flex">Dirección de recidencia</div>
                    <div className="display-flex">
                        <Field name="Pws_Rep_Legal_Direccion"
                            className={`form-know-you-item-input-smaller display-flex ${
                                hasError('Pws_Rep_Legal_Direccion') ? 'input-error' : ''
                            }`} />
                    </div>
                </div>
             

                <div className="col">
                    <div className="label-fields-peps-mobile display-flex">Teléfono principal</div>
                    <div className="display-flex">
                        <Field name="Pws_Rep_Legal_Telefono"
                            className={`form-know-you-item-input-smaller display-flex ${
                                hasError('Pws_Rep_Legal_Telefono') ? 'input-error' : ''
                            }`} />
                    </div>
                </div>
            </div>

            {/* Fila 3 */}
            <div className="row">
                <div className="col">
                    <div className="label-fields-peps-mobile display-flex">Correo electrónico</div>
                    <div className="display-flex">
                        <Field name="Pws_Rep_Legal_Correo" type="email"
                            className={`form-know-you-item-input-smaller display-flex ${
                                hasError('Pws_Rep_Legal_Correo') ? 'input-error' : ''
                            }`} />
                    </div>
                </div>

                <div className="col">
                    <div className="label-fields-peps-mobile display-flex">Ciudad residencia</div>
                    <div className="display-flex">
                        <Field as="select" name="Pws_Rep_Legal_Ciudad"
                            className={`form-know-you-item-input-smaller display-flex ${
                                hasError('Pws_Rep_Legal_Ciudad') ? 'input-error' : ''
                            }`}>
                            <option value="">Seleccione...</option>
                            {allCiudades?.ListCiudad?.Datos_Ciudad?.map((item:any, key: number) => (
                                <option key={key} value={item.s_codigo}>{item.s_nombre}</option>
                            ))}
                        </Field>
                    </div>
                </div>

                  <div className="col">
                     <div className={"label-fields-peps-mobile display-flex"}></div>
                     <div className="display-flex">
                        {/*  <Field name="Pws_Rep_Legal_Correo_Confirmacion" type="email"
                                onPaste={(e: any) => e.preventDefault()}
                                autoComplete="off"
                                className={`form-know-you-item-input-smaller display-flex ${
                                    hasError('Pws_Rep_Legal_Correo_Confirmacion') ? 'input-error' : ''
                                }`}/> */}
                     </div>
                 </div>

                 <div className="col">
                     <div className={"label-fields-peps-mobile display-flex"}></div>
                     <div className="display-flex">
                        {/*  <Field name="Pws_Rep_Legal_Correo_Confirmacion" type="email"
                                onPaste={(e: any) => e.preventDefault()}
                                autoComplete="off"
                                className={`form-know-you-item-input-smaller display-flex ${
                                    hasError('Pws_Rep_Legal_Correo_Confirmacion') ? 'input-error' : ''
                                }`}/> */}
                     </div>
                 </div>
            </div>
        </div>
    );
}
